module.exports = "<p *ngIf=\"(itemPromise | async) as item\">{{ item.isVisible }}</p>\n"